var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { INDRAApiService } from './api.indra.service';
import { URL_ROOT, URL_CREATE_UPDATE_NEW_PASSENGER, PAX_TYPE_INFANT_CODE } from '@ibe.config';
import { finalize } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
var PassengerService = /** @class */ (function () {
    function PassengerService(apiService) {
        this.apiService = apiService;
        this.isSavingNewPassenger = false;
    }
    PassengerService.prototype.savePassenger = function (passenger, pnr, passenger_id) {
        var travelDocument = passenger.travelDocument, emergencyContact = passenger.emergencyContact, frequentFlyer = passenger.frequentFlyer, contact = passenger.contact;
        var rq = __assign({}, passenger, { travelDocument: {
                address: {
                    address: travelDocument.address,
                    stateOrProvince: travelDocument.stateOrProvinceCode,
                    stateOrProvinceCode: travelDocument.stateOrProvinceCode,
                    postalCode: travelDocument.postalCode,
                    city: travelDocument.city,
                    country: travelDocument.country,
                    countryCode: travelDocument.country
                },
                redressNumber: travelDocument.redress,
                birthDate: travelDocument.birthDate,
                country: travelDocument.country,
                docNum: travelDocument.docNum,
                docType: travelDocument.docType,
                expiryDate: travelDocument.expiryDate,
                lifelong: travelDocument.lifelong,
                nationality: travelDocument.nationallity,
                infant: travelDocument.infant,
                gender: travelDocument.gender
            }, contact: {
                email: contact.email,
                telephone: {
                    number: contact.phone,
                    prefix: contact.phoneCountryCode,
                    type: contact.phoneType
                }
            }, frequentFlyer: {
                membershipId: frequentFlyer.FFnum,
                programId: frequentFlyer.FFid
            }, emergencyContact: {
                countryCode: emergencyContact.emCountry,
                emergencyFlag: !emergencyContact.declined,
                fullName: emergencyContact.emName,
                telephone: {
                    countryCode: emergencyContact.emPrefix,
                    phoneNumber: emergencyContact.emPhone
                }
            } });
        var URL = URL_ROOT + "booking/pnrs/" + pnr + "/passengers/" + passenger_id + "/update";
        return this.apiService.INDRA_put(URL, rq);
    };
    PassengerService.prototype.saveNewPassenger = function (passenger, passenger_id, passenger_type) {
        var _this = this;
        if (this.isSavingNewPassenger)
            return;
        this.isSavingNewPassenger = true;
        var travelDocument = passenger.travelDocument, emergencyContact = passenger.emergencyContact, frequentFlyer = passenger.frequentFlyer, contact = passenger.contact, mainInfo = passenger.mainInfo, studentInfo = passenger.studentInfo, residentInfo = passenger.residentInfo, workInfo = passenger.workInfo, travelInsurance = passenger.travelInsurance;
        var rq = {
            // ...passenger,
            paxId: passenger_id,
            paxType: passenger_type,
            title: mainInfo.title,
            name: mainInfo.name,
            surname: mainInfo.surname,
            studentDocNumber: studentInfo.studentDocNumber,
            studentfiscalNumber: studentInfo.studentfiscalNumber,
            residentDocNumber: residentInfo.residentDocNumber,
            residentfiscalNumber: residentInfo.residentfiscalNumber,
            tapCorporateNumber: frequentFlyer.tapCorporateNumber,
            workTrip: workInfo && workInfo.workTrip === 'yes' ? true : false,
            contact: {},
            /* contact: {
                email: contact.email,
                telephone: {
                    number: contact.phone,
                    prefix: contact.phoneCountryCode,
                    type: contact.phoneType
                }
            } as PassengerContact, */
            frequentFlyer: {
                membershipId: frequentFlyer.FFnum,
                programId: frequentFlyer.FFid
            }
        };
        if (emergencyContact) {
            rq['emergencyContact'] = {
                countryCode: emergencyContact.emCountry,
                emergencyFlag: !emergencyContact.declined,
                fullName: emergencyContact.emName && emergencyContact.emName.length > 0 ? emergencyContact.emName : null,
                telephone: {
                    countryCode: emergencyContact.emPrefix,
                    phoneNumber: emergencyContact.emPhone
                }
            };
        }
        if (travelDocument) {
            rq['travelDocument'] = {
                redressNumber: travelDocument.redress,
                birthDate: travelDocument.birthDate ? travelDocument.birthDate : mainInfo.birthDate,
                country: travelDocument.country,
                docNum: travelDocument.docNum,
                docType: travelDocument.docType,
                expiryDate: travelDocument.expiryDate,
                lifelong: travelDocument.lifelong,
                nationality: travelDocument.nationallity,
                infant: travelDocument.infant ? travelDocument.infant : (passenger_type === PAX_TYPE_INFANT_CODE) ? true : false,
                gender: travelDocument.gender ? travelDocument.gender : mainInfo.gender
            };
            if (travelDocument.address) {
                rq['travelDocument']['address'] = {
                    address: travelDocument.address
                };
                if (travelDocument.stateOrProvinceCode) {
                    rq['travelDocument']['address']['stateOrProvince'] = travelDocument.stateOrProvinceCode;
                    rq['travelDocument']['address']['stateOrProvinceCode'] = travelDocument.stateOrProvinceCode;
                }
                if (travelDocument.postalCode) {
                    rq['travelDocument']['address']['postalCode'] = travelDocument.postalCode;
                }
                if (travelDocument.city) {
                    rq['travelDocument']['address']['city'] = travelDocument.city;
                }
                if (travelDocument.country) {
                    rq['travelDocument']['address']['country'] = travelDocument.country;
                    rq['travelDocument']['address']['countryCode'] = travelDocument.country;
                }
            }
            if (!rq['travelDocument']['gender'] || !rq['travelDocument']['birthDate']) {
                delete rq['travelDocument'];
            }
            /*
            if (!rq['travelDocument']['gender']) {
                delete rq['travelDocument']['gender'];
            }
            if (!rq['travelDocument']['birthDate']) {
                delete rq['travelDocument']['birthDate'];
            }
            */
            // if traveldocs filled by user is only gender and birthdate and no doctype/docNumber this
            // means that the form does not require the traveldoc, thus we only need to send gender and birthdate
            // and/or nationality and avoid sending partial traveldoc details that will cause API errors
            if (rq['travelDocument']) {
                if (rq['travelDocument']['gender'] && rq['travelDocument']['birthDate'] && !rq['travelDocument']['expiryDate'] &&
                    !rq['travelDocument']['lifelong'] && !rq['travelDocument']['docType'] && !rq['travelDocument']['docNum']) {
                    delete rq['travelDocument']['expiryDate'];
                    delete rq['travelDocument']['lifelong'];
                    delete rq['travelDocument']['docNum'];
                    delete rq['travelDocument']['docType'];
                    delete rq['travelDocument']['country'];
                }
                if (rq['travelDocument']['redressNumber'] === '') {
                    delete rq['travelDocument']['redressNumber'];
                }
            }
        }
        if (travelInsurance) {
            rq['travelInsurance'] = {
                vatNumber: travelInsurance.vatNumber,
                address: travelInsurance.address,
                zipcode: travelInsurance.zipcode,
                city: travelInsurance.city,
            };
        }
        else {
            delete rq['travelInsurance'];
        }
        return this.apiService.INDRA_put(URL_CREATE_UPDATE_NEW_PASSENGER, rq).pipe(finalize(function () { return _this.isSavingNewPassenger = false; }));
    };
    PassengerService.ngInjectableDef = i0.defineInjectable({ factory: function PassengerService_Factory() { return new PassengerService(i0.inject(i1.INDRAApiService)); }, token: PassengerService, providedIn: "root" });
    return PassengerService;
}());
export { PassengerService };
